import React, { useState, useEffect } from "react";
import "./MarketOddBtn.scss";
import { LockOutlined } from "@mui/icons-material";

type PropType = {
  mainValue?: any;
  mainValueClass?: "price" | "runs";
  subValue?: any;
  subValueClass?: "size" | "odds";
  disable?: boolean;
  oddType: "back-odd" | "lay-odd" | "odds-yes-cell" | "odds-no-cell" | "suspended-btn" | "premium-odd";
  valueType?: "matchOdds" | "bookmakerOdds" | "fancyMarketOdds" | "binaryOdds" | "premiumOdds";
  onClick?: () => void | undefined;
  oddsSet?: number[];
  showSubValueinKformat?: boolean;
};

const MarketOddBtn: React.FC<PropType> = (props) => {
  const {
    mainValue,
    mainValueClass,
    subValue,
    subValueClass,
    disable,
    oddType,
    valueType,
    onClick,
    oddsSet,
    showSubValueinKformat,
  } = props;
  const [currentValue, setCurrentValue] = useState<number>(0);
  const [classes, setClasses] = useState<string>("exch-odd-button");
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(null);
  const [currentOdds, setCurrentOdds] = useState<number[]>([]);
  const [volume, setVolume] = useState<number>();
  const subValprecision: number = valueType === "matchOdds" ? 2 : 0;

  useEffect(() => {
    if (subValue) {
      if (valueType === "matchOdds") setVolume(subValue * 100);
      else setVolume(subValue);
    }
  }, [subValue, valueType]);

  const oddValueChanged = () => {
    if (timer) clearTimeout(timer);
    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      // let showAnimation = true;
      // if (oddsSet && oddsSet.length > 0) {
      //   showAnimation = !currentOdds.includes(chVal);
      //   setCurrentOdds(oddsSet);
      // }
      // if (showAnimation) {
        if (cVal && chVal !== cVal) {
          if (!classes.includes("odd-change"))
            setClasses(classes + " odd-change");
          const newTimer = setTimeout(() => {
            setClasses(classes.replace(" odd-change", ""));
          }, 5000);
          setTimer(newTimer);
        }
      // }
    }
  };

  useEffect(() => oddValueChanged(), [mainValue]);

  return (
    <div className="exch-odd-view">
      {mainValue && Number(mainValue) > 0 ? (
        <div
          className={
            disable ? `${oddType} disabled ` + classes : `${oddType} ` + classes
          }
          onClick={() => onClick?.()}
        >
          <div className="exch-odd-button-content">
            <div className={mainValueClass ? mainValueClass : "price"}>
              {Number.isNaN(Number(mainValue)) ? (
                <br></br>
              ) : valueType === "fancyMarketOdds" || valueType === "bookmakerOdds" ? (
                Number(mainValue)
              ) : (
                Number(mainValue).toFixed(2)
              )}
            </div>

            {oddType !== 'premium-odd' ? (
              <div className={subValueClass ? subValueClass : 'size'}>
                {volume
                  ? showSubValueinKformat && Number(volume > 999)
                    ? Number(volume / 1000).toFixed(subValprecision) + 'K'
                    : Number(volume).toFixed(subValprecision)
                  : '0.00K'}
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className={`${oddType} disabled ` + classes}>
          <LockOutlined
            className="lock-icon"
          />
        </div>
      )}
    </div>
  );
};

export default MarketOddBtn;
